import { Alert, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export interface AcceptedRequestConfirmationProps {
  transfererName: string;
}

export function AcceptedRequestConfirmation(props: AcceptedRequestConfirmationProps) {
  const { transfererName } = props;
  return (
    <Stack alignItems="center" sx={{ height: "100%", justifyContent: "space-evenly" }}>
      <Text variant="body1">
        You have successfully accepted the transfer. The shift is now yours to work.
      </Text>
      <Alert severity="info" variant="filled">
        Remember: if you cancel or No Call No Show, it will affect {transfererName}&apos;s score.
        They could be restricted.
      </Alert>
    </Stack>
  );
}
